import { NavBar } from '@/components/NavBar';
import PageWithTOC, { Section } from '@/components/PageWithTOC';
import { PRODUCT_EMAIL, PRODUCT_NAME } from '@/shared/constance';


const termOfUseSections: Section[] = [
  {
    id: '',
    title: '',
    content: <p className="text-base font-semibold text-white">感谢您使用 {PRODUCT_NAME}！</p>,
  },
  {
    id: 'introduction',
    title: '1. 接受本服务条款',
    content: (
      <div className="text-base font-normal text-white">
        <p>
          1.1 本服务条款，包括我们的{' '}
          <a className="underline" target="_blank" href="/policies/privacy-policy">
            隐私政策
          </a>{' '}
          ，通过引用纳入本条款（合称"本协议"），是您应当阅读的重要文件，是您与 STREAMLAKE PTE. LTD.
          及其关联公司（统称"{PRODUCT_NAME}"、"公司"、"我们"） 就您使用 {PRODUCT_NAME}{' '}
          及相关软件应用程序和网站（统称"服务"、"{PRODUCT_NAME}"）
          之间具有法律约束力的合同。"客户"、"您"和"您的"是指接受本协议、下订单、创建账户或以其他方式使用服务的个人。
        </p>
        <p>
          如果服务由获得授权代表公司、组织或其他实体接受本协议的个人代表该实体使用，
          则所有对"客户"、"您"或"您的"的引用均指该实体及其关联公司。如果您是公司、
          组织或其他实体，代表您接受本协议的个人声明并保证其有权约束您接受本协议。
        </p>
        <p>
          1.2 我们的服务提供一套由机器学习驱动的编码工具，帮助开发者更轻松高效地编写代码，
          并可提供建议代码、输出或其他功能。您可以使用我们的服务编写代码、软件应用程序、
          脚本和其他基于代码的产品。在您遵守本条款的前提下，公司授予您访问和使用服务的有限权利。
          作为服务的一部分，您可以向服务输入、上传和提交信息或其他材料（"输入"，包括但不限于
          代码、文本、URL或其他信息、数据、数据集、文档、文件和其他材料），并基于您提供的输入
          接收代码、输出或其他功能（统称"输出"）（输入和输出统称"内容"）。我们可能使用内容
          来提供服务、遵守适用法律、执行我们的条款和政策，并保持服务安全。通过向服务提交输入，
          您声明并保证您拥有我们根据本条款处理输入并向您提供服务所必需的所有权利、许可和权限。
        </p>
        <p>
          1.3 如果您使用我们提供的 {PRODUCT_NAME} 和相关服务（统称"服务"），无论全部还是部分，
          您即被视为在此声明并保证您在法律上能够受到约束；并同意受到约束并接受本条款以及通过
          引用明确纳入本条款的其他相关文件。如果您代表公司、协会、合伙企业、组织或其他实体
          （无论部分还是全部）使用我们的服务，则您同意、声明、保证并承诺"您"和"您的"包括
          您和您所代表的公司、协会、合伙企业、组织或其他实体；您已获得并将继续获得该公司、
          协会、合伙企业、组织或其他实体的正当授权，代表其同意并约束该公司、协会、合伙企业、
          组织或其他实体接受本条款；该公司、协会、合伙企业、组织或其他实体对您使用服务以及
          该公司、协会、合伙企业、组织或其他实体授权的任何其他个人（包括但不限于该公司、
          协会、合伙企业、组织或其他实体的任何高级职员、董事、员工、代理人和顾问）使用您的
          账户承担法律责任。
        </p>
        <p className="font-semibold">
          1.4 您必须仔细阅读并充分理解本条款，包括任何可能免除或限制公司责任和/或职责的条款
          以及任何可能限制和/或放弃您权利的条款，因为它们适用于您对服务的使用。特别是，
          本条款包含争议解决和仲裁条款，该条款影响您在本条款下的权利以及您可能与公司发生的
          争议。您使用服务的前提是您接受本条款。如果您不同意或不接受本条款，您不得使用
          {PRODUCT_NAME} 或任何其他服务。
        </p>
        <p>
          <span className="font-semibold">1.5 修改：</span>为了提供更好的服务或出于法律、
          监管或安全原因，我们保留不时修改、替换和/或以其他方式更新本条款的权利。我们将
          尽商业上合理的努力通知您本条款的任何重大变更。更新的条款将在网站上发布更新条款
          的同一天生效并替换原条款，除非条款中另有说明。您应定期查看本条款以检查此类变更，
          或通过点击网站上的通知、推送消息或电子邮件同意我们更新的条款。如果您不同意或不
          接受更新的条款，您应选择不使用 {PRODUCT_NAME} 或任何相关服务。如果您继续使用
          {PRODUCT_NAME} 或任何相关服务，您将被视为已阅读、理解并接受更新的条款。
        </p>
        <p className="font-semibold">
          仲裁通知。您同意根据本协议产生的争议将通过下文规定的具有约束力的个人仲裁解决，
          通过接受本条款，您和 {PRODUCT_NAME} 均放弃陪审团审判的权利或参与任何集体诉讼
          或代表性诉讼的权利。
        </p>
      </div>
    ),
  },
  {
    id: 'registration-and-use',
    title: '2. 注册和使用',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <div>
          <p className="font-semibold">2.1 您的资格</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              您必须年满18岁或您所在司法管辖区的法定成年年龄（以较高者为准）。通过使用服务，
              您确认您已超过本条款规定的相关年龄，您的注册和使用服务符合您所在地区的所有适用法律。
              如果我们得知有人在未达到上述规定年龄的情况下使用服务，我们将终止该账户。
            </li>
            <li>
              任何未满13岁或您所在司法管辖区适用法律规定的其他最低年龄（"最低年龄"）的人员
              不得使用服务。如果您已达到最低年龄但未达到您所在司法管辖区适用法律规定的成年年龄
              （"成年年龄"），您只能通过您的父母或法定监护人的代理在网站上使用和注册 {PRODUCT_NAME}
              账户（"账户"），您的父母或法定监护人在此代表您并接受本条款。
            </li>
            <li>
              在此类适用法律法规要求父母同意或授权的情况下，您有义务向我们提供此类同意或授权的证据，
              包括根据适用法律法规的要求，未成年人父母责任持有人的同意或授权。在我们收到此类同意
              或授权证据之前，我们可能拒绝处理或继续处理未成年人的个人信息，或向未成年人提供或
              继续提供服务。
            </li>
            <li>
              如果您在您的国家或地区是未成年人，您对服务的使用可能受到进一步的年龄限制，
              无论是由我们还是与提供某些服务相关的任何第三方供应商施加的限制。您可能无法使用
              或只能有限地访问这些服务，例如参与奖励计划、在没有父母或法定监护人协助的情况下充值等。
            </li>
            <li>
              如果您得知未达到最低年龄的儿童已注册 {PRODUCT_NAME} 账户，或未达到成年年龄的儿童
              的账户未在适当的代理或监护下注册，您可以通过 {PRODUCT_EMAIL} 提醒我们。我们将
              及时验证，采取措施从 {PRODUCT_NAME} 中删除此类儿童的账户信息并终止该儿童的账户。
            </li>
          </ol>
        </div>

        <div>
          <p className="font-semibold">2.2 许可</p>
          <p>
            在您遵守本条款的前提下，我们特此授予您非独占、不可再许可、不可转让的个人有限许可，
            仅在您的个人智能手机、平板电脑、计算机或其他移动或无线设备上使用 {PRODUCT_NAME}
            （该设备必须被我们指定为与 {PRODUCT_NAME}{' '}
            兼容使用）。公司保留本条款未明确授予您的所有权利。
            您承认并同意我们可以随时、因任何原因、有因或无因地终止此许可。
          </p>
        </div>

        <div>
          <p className="font-semibold">2.3 访问 {PRODUCT_NAME}</p>
          <p>
            服务以"按现状"和"按可用性"的基础向您提供，风险由您自行承担。我们的目标是最大限度地
            减少技术错误造成的中断；但是，我们无法保证 {PRODUCT_NAME}{' '}
            始终持续、不间断或无错误地运行。 可能会有某些时候，{PRODUCT_NAME} 的某些功能或特性或通过{' '}
            {PRODUCT_NAME} 提供的内容， 或整个 {PRODUCT_NAME}
            ，变得不可用（无论是计划内还是计划外的基础上），或被我们自行决定
            修改、暂停或撤回，而不通知您。您同意我们不会因 {PRODUCT_NAME} 或 {PRODUCT_NAME} 的任何
            功能、部分或内容的不可用、修改、暂停或撤回而对您或任何第三方承担责任。如果由于我们无法
            控制的任何事件（例如（不限于）在您设备上运行的任何软件或操作系统的性能或任何连接的软件、
            硬件、网络或服务），导致您无法正常或完全访问服务，我们不承担责任。
          </p>
        </div>

        <div>
          <p className="font-semibold">2.4 账户注册</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              要使用某些服务，您必须注册账户。当您注册账户时，可能需要向我们提供有关您自己的信息，
              例如您的姓名、用户名、电子邮件地址或其他联系信息。您也可以创建账户或关联其他账户，
              例如您的 GitHub 账户、Google 账户（"账户"）。
            </li>
            <li>
              您应根据注册页面上的说明向我们提供信息并完成所有注册程序。通过创建账户：
              <ol className="mt-2 list-[lower-roman] space-y-2 pl-8">
                <li>
                  您承诺并应提供我们可能不时要求的真实、准确、最新和完整的信息，不得向我们提供
                  任何虚假或误导性信息；
                </li>
                <li>
                  您授权我们假定任何使用您的用户名和密码使用 {PRODUCT_NAME} 的人要么是您，
                  要么是被授权代表您行事的人；
                </li>
                <li>您不得冒充或试图冒充他人；以及</li>
                <li>您必须保护您账户的用户名和密码，并保持其秘密和机密。</li>
              </ol>
            </li>
          </ol>
        </div>

        <div>
          <p className="font-semibold">2.5 账户安全和管理</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>当您使用 {PRODUCT_NAME} 和任何相关服务时，您承诺并应遵守所有适用的法律法规。</li>
            <li>
              如果您授权任何人代表您使用 {PRODUCT_NAME}，您将确保他们始终遵守本条款。您有责任
              确保您的账户安全。建议您妥善保管您的账户并确保适当注销。您必须保护与您账户相关的
              用户名和密码，并定期更改。
            </li>
            <li>
              您的账户只能由您自己使用，您不得出借、赠送或出租账户，或违反本条款转让、出售或
              共享账户。否则，您将对由此产生的任何法律后果负责。
            </li>
          </ol>
        </div>
      </div>
    ),
  },
  {
    id: 'instructions-of-conduct',
    title: '3. 行为准则',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <div>
          <p>3.1 您对服务的访问和使用受本条款以及所有适用法律法规的约束。您不得：</p>
          <ol className="mt-2 list-[lower-alpha] space-y-2 pl-4">
            <li>
              如果您不完全有能力且在法律上有资格同意本条款，或未经您的父母或法定监护人授权
              使用服务，则不得访问或使用服务；
            </li>
            <li>
              未经授权复制、修改、改编、翻译、删除、更改、逆向工程、拆解、反编译或创建服务或
              其中包含的任何内容的任何衍生作品，包括任何文件、表格或文档（或其任何部分），
              或确定或试图确定服务或其任何衍生作品所体现的任何源代码、算法、方法或技术；
            </li>
            <li>全部或部分分发、许可、转让或出售任何服务或其任何衍生作品；</li>
            <li>
              未经我们书面同意，以收费方式销售、出租或租赁服务，或使用服务进行广告宣传或
              执行任何商业招揽；
            </li>
            <li>
              未经我们书面同意，将服务用于任何商业或未经授权的目的，包括传播或促进任何
              商业广告或招揽或垃圾邮件；
            </li>
            <li>
              干扰或试图干扰服务的正常工作，破坏网站或连接到服务的任何网络，
              或绕过我们可能用来防止或限制访问服务的任何措施；
            </li>
            <li>
              将服务或其任何部分纳入任何其他程序或产品。在这种情况下，我们保留拒绝服务、
              终止账户或限制访问服务的权利，由我们自行决定；
            </li>
            <li>使用自动化脚本从服务收集信息或以其他方式与服务交互；</li>
            <li>
              冒充任何个人或实体，或虚假陈述或以其他方式歪曲您或
              您与任何个人或实体的关系，包括给人的印象是任何
              您上传，张贴，传输，分发或以其他方式提供的内容散发 来自服务；
            </li>
            <li>
              恐吓或骚扰他人，或宣传色情内容，暴力或 基于种族、性别、宗教、国籍、残疾、性别的歧视
              方位或年龄；
            </li>
            <li>未经授权使用或企图使用他人的帐户、服务或系统 或在服务上创建虚假身份；</li>
            <li>
              以可能产生利益冲突或损害“服务”的方式使用“服务”
              使用本服务的目的，例如与其他用户进行交易评论或撰写或 征集虚假评论；
            </li>
            <li>
              使用本服务上载、传输、分发、存储或以其他方式提供
              任何方式：包含病毒、特洛伊木马、蠕虫、逻辑炸弹或其他材料的文件 恶意的或技术上有害的；
            </li>
            <li>
              任何未经索取或未经授权的广告、招揽、宣传材料；
              “垃圾邮件”、“垃圾邮件”、“连锁信件”、“传销计划”或任何其他被禁止的形式 征集;
            </li>
            <li>
              征求，或试图征求任何第三方的任何私人信息，包括
              地址，电话号码，电子邮件地址，号码和个人身份的特征
              文件（如身份证号码、护照号码）或信用卡 数字;
            </li>
            <li>任何侵犯或可能侵犯任何版权、商标或其他知识产权的材料 他人的财产或隐私权；</li>
            <li>任何诽谤任何人、淫亵、冒犯、色情、 可恶的或煽动性的；</li>
            <li>任何构成、鼓励或提供犯罪、危险活动或自残的指示的材料；</li>
            <li>
              任何故意设计用来煽动或激怒人们，特别是欺凌和欺凌，或旨在骚扰、伤害、伤害、惊吓、
              困扰、尴尬或冒犯人们；
            </li>
            <li>包含任何形式威胁的任何材料，包括身体威胁 暴力;</li>
            <li>
              任何种族歧视或歧视的材料，包括基于某人的种族、宗教、年龄、性别、残疾或性别的歧视；
            </li>
            <li>
              材料，在我们自己的判断中，是令人反感的或限制或阻止任何其他人使用服务，或可能暴露
              {PRODUCT_NAME}、服务或我们任何其他用户的任何伤害或责任；
            </li>
            <li>
              使用服务或任何内容、数据、信息或其他材料，通过服务（包括输出）提供，直接或间接地，
              创建、测试、改进、培训或以其他方式开发您的或任何第三方的
              人工智能或机器学习模型、系统、架构、权重或相关技术；
            </li>
          </ol>
        </div>

        <p>
          在下列情况下，根据本条款授予您的所有权利可能被终止
          如发现违反上述任何条款，我们将自行决定。
        </p>

        <div>
          <p>
            3.2人工智能和机器学习是快速发展的研究领域。
            我们一直在努力改进我们的服务，使其更加准确、可靠、
            安全，有益。考虑到机器学习的概率性质，使用我们的
            在某些情况下，服务可能导致不能准确反映实际情况的输出 人、地点或事实。{' '}
          </p>
          <p>当您使用我们的服务时，您理解并同意： </p>
          <ol className="list-[lower-roman] space-y-2 pl-4">
            <li>
              输出可能并不总是准确的。您不应该依赖生成的输出
              使用我们的服务作为真相或事实的唯一来源而产生的信息 信息，或作为专业建议的替代品。
            </li>
            <li>
              你们有责任评估输出的准确性和适用性 你的特殊需求。这包括：在必要时事先进行人工审查
              应用或传播我们服务的输出；让你的 对产品的知识产权有自己的决定；
              除其他事项外，请考虑您的使用场景和 有关管辖权。尽管有上述规定，您不能将输出用于
              任何非法或侵权的目的。
            </li>
            <li>
              您不得将与个人有关的任何输出用于可能具有的任何目的
              对该人的法律或物质影响，如信用、教育、 就业，住房，保险，法律，医疗，或其他重要的决定
              他们。
            </li>
            <li>
              我们的服务可能会提供不完整、不正确或冒犯性的输出
              代表我们的观点。如果输出引用了任何第三方产品或服务，则它
              并不意味着第三方认可或隶属于我们。
            </li>
          </ol>
          <p>
            我们不作任何陈述，保证，保证或条件，任何输出是免费的
            从错误或错误，真实，准确，可验证，可靠，完整或最新
            并放弃任何和所有的陈述，保证，保证和任何条件
            输出的性质，明示或暗示。为您生成的输出不是唯一的；的
            服务可以为不同的用户生成相同或类似的输
          </p>
        </div>

        <p>
          3.3我们不能也不保证任何内容（定义见下文）将不受
          病毒和/或其他可能具有污染或破坏性元素的代码。这是你的。
          实施适当的信息技术安全保障措施的责任 （包括杀毒和其他安全检查），以满足您的特殊要求
          {PRODUCT_NAME}和内容的安全性和可靠性 他们。
        </p>

        <p>
          3.4如果您使用{PRODUCT_NAME}导致需要维修或更换财产，
          材料、设备或数据，我们将不负责此类费用。
        </p>

        <p>
          3.5您负责遵守适用法律法规、合格政府机构的要求和
          我们的内部政策。除了遵守任何相关司法或行政机关的
          内容删除订单或用户或任何第三方的请求，或响应其他用户的投诉或任何第三方的投诉，
          或如果我们，在我们自己的判断中，认为任何内容不符合这些条款，我们可以采取任何措施，
          包括但不限于删除或拒绝显示此类内容。
        </p>

        <p>
          3.6您承认并同意，您上传或发布的内容将被考虑
          非专有和非机密。您不得上传或传输任何您不同意的内容
          被认为是专有的或机密的。您可以决定和控制的程度
          您的内容的可用性（即是否对所有其他用户，您选择的用户或仅对用户） （根据特性和功能）通过
          {PRODUCT_NAME}的设置 在{PRODUCT_NAME}中可用。
        </p>
        <p>
          3.7本服务可能包括自动执行代码建议的功能 人工审核或确认，并将相应的标识清楚。通过启用这个
          功能，您承认并同意您承担与 执行自动生成的代码，包括但不限于系统中断；
          软件缺陷、数据丢失和安全漏洞。你要全权负责
          使用此功能造成的任何影响，包括确保适当的保障措施； 测试和监控都到位了。
        </p>
      </div>
    ),
  },
  {
    id: 'intellectual-property',
    title: '4. 知识产权和内容',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          4.1 我们尊重知识产权，鼓励您上传或传输原创内容，我们将根据适用的法律法规采取措施
          保护您的知识产权。
        </p>

        <p>
          4.2 在您使用服务的过程中，您可能能够发布、上传或提交通过服务提供的内容
          （与输入统称为"您的内容"）。在公司与您之间，公司不声称对您的内容拥有任何所有权；
          但前提是，公司或其关联公司及其各自的许可方拥有并将继续拥有服务以及用于生成任何
          输出的任何和所有其他软件或技术。
        </p>

        <p>
          4.3 您保证并承诺您拥有输入的知识产权，或您已获得相关所有者对使用输入的合法授权，
          并且您对输入的使用不得违反任何适用的法律法规或侵犯任何第三方的合法权利和利益
          （包括但不限于版权、专利、商标和其他知识产权以及人格权、个人数据权和其他权利和利益）。
          您不得
        </p>
        <ol className="list-[lower-roman] space-y-2 pl-4">
          <li>在未明确引用服务的情况下发布服务生成的任何输出，或</li>
          <li>歪曲任何输出的来源或它是由人工智能生成的事实。</li>
        </ol>
        <p>
          在收到知识产权所有者或任何其他人关于任何涉嫌或实际知识产权侵权的通知后，
          我们保留审核、阻止或删除输入（或其部分）的权利，您应对我们或我们的关联公司
          因此类涉嫌或实际侵权而产生、与之相关和/或与之相关的任何和所有损失、损害或其他
          后果承担责任。
        </p>

        <p>
          4.4 在适用法律允许的范围内，服务过程中生成的输出的知识产权和其他财产权益
          （如有）应根据适用法律的规定归属于其所有者。
        </p>

        <p>
          4.5 您承认并同意，如果您根据适用法律对输入和/或输出拥有知识产权、肖像权或其他
          合法权利或利益，您使用服务不构成对此类合法权利或利益的转让，除非您和我们另有约定。
          具体而言，未经我们的书面许可，您不得为任何商业目的使用、复制、分发、创建衍生作品
          或修改输出。
        </p>

        <div>
          <p className="font-semibold">4.6 许可</p>
          <p>
            4.6.1 在符合适用法律的合法商业目的的前提下，{PRODUCT_NAME} 在其业务运营期间 和{' '}
            {PRODUCT_NAME} 开展业务的地区内，拥有非独占、免版税的权利和许可，使用您根据
            适用法律拥有使用权利的内容，该内容应包括您提供或上传到服务的输入以及使用我们服务
            期间生成的输出，包括托管、存储、传输、公开展示、公开表演（包括通过数字音频传输）、
            向公众传播、复制、为显示目的而修改、从中创建衍生作品以及以任何媒体格式和通过任何
            媒体渠道全部或部分分发输入和输出的权利。
          </p>

          <p>
            4.6.2 我们可以自行决定或通过向第三方许可，使用或开发上述内容（全部或部分），
            用于推广、产品/功能升级以及研究新产品/功能的目的。您承诺不就我们使用或开发
            内容而主张个人权利或财产权。
          </p>

          <p>
            4.6.3在不限制前述许可的通用性的前提下，{PRODUCT_NAME}可以
            出于合法的商业目的处理使用数据、汇总数据或输入，我们可以
            并根据适用情况使用“您的内容”提供和改进“服务” 法律包括但不限于：
          </p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>为计费目的跟踪服务的使用情况；</li>
            <li>提供支持服务，例如使用人工智能生成代码、输出或其他 基于您的输入的功能；</li>
            <li>
              通过临时上传代码库中的代码来构建代码库索引
              Codebase&quot;)到我们的服务器来计算嵌入。一旦处理完成，
              生成的嵌入以及相关的元数据和代码库文件将被保留
              如果你不喜欢，那就储存起来吧！如果要我们存储，可以选择删除代码库索引
              ，一旦您选择删除，我们将删除您的代码库和生成的嵌入和 我们服务器中的相关元数据；
            </li>
            <li>监控服务的性能和稳定性；</li>
            <li>防止或解决技术问题；</li>
            <li>
              improve the Services, its other products and services, and to develop new products and
              services;改进服务，其其他产品和服务，并开发新产品和服务；
            </li>
            <li>
              创建、测试、改进或以其他方式开发服务、系统、架构、权重或相关技术， 由{PRODUCT_NAME}
              在服务中使用；
            </li>
            <li>对于所有其他合法的商业实践，如分析、基准测试和报告。</li>
          </ol>

          <p>
            4.6.4如果您不想让我们继续使用所有或部分许可内容，您可以通知我们撤销授权，
            通过发送电子邮件到<a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>。
          </p>
        </div>

        <p>
          4.7尽管有前文规定，由一个用户提供的全部或部分用户内容
          可由另一用户提取以制作额外的用户内容，但须事先遵守
          用户批准（如适用）。当您选择传输或上传用户时
          内容，其中可能包括其他用户和/或我们向其他平台生成的内容
          或由第三方运营的网站，您应遵守这些条款和 使用该等其他平台或网站的任何条款及条件。
        </p>

        <p>
          4.8您承认{PRODUCT_NAME}及通过{PRODUCT_NAME}提供的内容是
          受商标、著作权及其他知识产权保护。你 您不得使用我们服务中的内容，除非您获得其所有者的许可
          其他适用法律允许的。不删除，模糊，或更改任何法律通知
          在我们的服务中或与我们的服务一起显示的。此外，您不得出售，复制，
          分发，修改，展示，公开表演，准备衍生作品，转发
          或以任何方式将我们拥有的任何内容用于任何公共或商业目的
          未经我们事先书面同意。不妨碍我们采取其他补救措施
          有权，我们保留权利，无论是否通知，在任何时候，在我们的唯一
          自行决定暂停及/或终止任何用户的帐户谁侵犯或是 涉嫌侵犯任何商标、版权或其他知识产权。
        </p>
      </div>
    ),
  },
  {
    id: 'copyright-complaints',
    title: '5. 版权投诉',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          服务的代码生成功能旨在生成新的原创代码。通过特定请求或其他提示操作试图生成现有的
          受版权保护的代码是违反本条款的行为。如果您遇到违反适用法律的服务不当响应或输出，
          或者如果您认为您的知识产权受到侵犯，请向以下地址发送通知。我们可能会删除或禁用
          我们认为违反本条款或被指控侵权的内容，并在适当情况下终止重复侵权者的账户。
        </p>
        <p>
          <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>
        </p>
        <p>有关版权侵权的书面声明必须包括以下信息：</p>
        <ul className="list-disc space-y-2 pl-6">
          <li>被授权代表版权权益所有者行事的人员的实体或电子签名</li>
          <li>您声称被侵权的受版权保护作品的描述</li>
          <li>涉嫌侵权材料在我们网站上位置的描述，以便我们能够找到它</li>
          <li>您的地址、电话号码和电子邮件地址</li>
          <li>您的声明，表明您善意相信争议使用未经版权所有者、其代理人或法律授权</li>
          <li>
            您的声明，表明您通知中的上述信息是准确的，并且在伪证罪的处罚下，您是版权所有者
            或被授权代表版权所有者行事。
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 'commercial-terms',
    title: '6. 商业条款',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          6.1 我们向您提供的服务可能是免费或付费服务。具体详情以 {PRODUCT_NAME} 上显示的信息为准。
        </p>
        <p>
          6.2 您理解并同意，我们可能会根据业务发展需要调整我们对服务收费的标准和方法，
          也可能开始对一些以前免费的服务收费。我们将通过 {PRODUCT_NAME} 通知或公布此类变更。
          为明确起见，通过 {PRODUCT_NAME} 提供免费服务不应被解释为我们放弃未来收费的权利。
        </p>
        <p>
          6.3 您理解并同意 {PRODUCT_NAME} 可能包含我们关联公司或第三方提供的其他服务内容。 我们仅在{' '}
          {PRODUCT_NAME} 上为您的便利提供这些服务的订阅和/或访问点。如果您希望使用
          此类服务，您应单独与相应的服务提供商签订协议，支付相应费用（如有），并承担所有
          潜在风险。我们不对我们关联公司或其他第三方提供的服务提供任何形式的保证或担保。
        </p>
      </div>
    ),
  },
  {
    id: 'exclusion-warranties',
    title: '7. 免责声明、赔偿和责任',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <div>
          <p className="font-semibold">7.1排除保证</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              您使用本服务的风险完全由您自行承担。通过使用服务，您
              您确认您已仔细考虑并完全理解这些条款 对你的法律权利的影响。
            </li>
            <li>
              服务是按“原样”提供的，我们不对您作出任何保证或声明
              关于服务。特别是，我们不对您作任何陈述或保证 :
              <ol className="mt-2 list-[lower-roman] space-y-2 pl-8">
                <li>您的使用将符合您的需求；</li>
                <li>您的使用将是连续的、及时的、安全的或无错误的；</li>
                <li>您使用服务所获得的信息将是准确可靠的；或</li>
                <li>任何软件提供给您的服务中存在的缺陷将被纠正。</li>
              </ol>
              在法律允许的最大范围内，我们 hereby disclaim all warranties of any kind,
              无论明示或暗示，法定或任何其他性质，包括但不限于任何保证
              商业性、非侵权性及适合特定目的。上述规定不影响任何 法律允许的排除或限制。
            </li>
            <li>
              您同意赔偿、为{PRODUCT_NAME}
              、其高级职员、董事、员工、代理人和关联公司进行辩护并使其免受任何索赔、损害、义务、损失、责任、成本或债务以及费用（包括律师费）的损害。
            </li>
            <li>
              您同意为我们、我们的母公司、 子公司和关联公司以及我们各自的管理人员、董事、
              任何及所有索赔、责任、费用的雇员、代理人和顾问 费用，包括但不限于律师费；费用和开支
              因您、您的内容或您的 适用法律法规或本条款，包括您的义务； 此声明和保证。
            </li>
            <li>
              在适用法律下，此类责任可能是无限的或被排除在外的
              还有法规，我们对你不负责你同意辩护，赔偿，和
              保护我们、我们的母公司、子公司和附属公司，以及我们的每一个
              各自的官员，董事，员工，代理和顾问来自任何和所有
              索赔、负债、成本和费用，包括但不限于：
              attorneys&apos;在赔偿基础上的费用和开支，就您使用的 服务和/或
              {PRODUCT_NAME}，或因您或任何第三方使用该等信息而访问任何信息 其他人员，无论是否授权。
            </li>
            <li>
              您同意{PRODUCT_NAME}对任何损失或损害（无论是直接的或间接的）不承担任何责任
              （或间接）你遭受的损失是由于：
              <ol className="mt-2 list-[lower-roman] space-y-2 pl-8">
                <li>
                  任何中断、拦截、暂停、延迟、丢失、不可用或其他 在提供服务或您使用{PRODUCT_NAME}
                  时，传送失败 与服务或您使用{PRODUCT_NAME}有关的说明或信息
                  ，或因与本服务连接或您使用{PRODUCT_NAME}而引起的任何
                  我们无法合理控制的行为、疏忽或情况，包括没有 限制信息网络设备的维护或连接故障；
                  计算机、通信或其他系统故障，黑客活动，计算机
                  病毒、停电、罢工、叛乱、火灾、洪水、风暴、爆炸、战争、
                  流行病、政府行为、司法和行政当局的命令或 其他第三方原因；或
                </li>
                <li>
                  传输和/或存储与您有关的信息和/或数据 服务、{PRODUCT_NAME}
                  和/或您据此进行的交易或交易 通过或在任何通信系统、设备或仪器中提供的服务
                  网络提供商。
                </li>
              </ol>
            </li>
            <li>
              如果您违反或涉嫌违反适用的法律法规或这些
              条款，我们保留采取一切必要行动的权利(包括但不限于
              暂停或终止您的帐户或您对服务的使用，或向 有关当局)立即通知，恕不另行通知。
            </li>
            <li>
              根据适用的法律法规，我们不会也不会对此负责
              任何直接的、附带的、后果性的或间接的损害、损失或损坏
              数据、利润损失、收入损失、商誉、机会或预期损失
              储蓄或任何其他任何类型的损失或损害，导致您访问，
              依赖，或使用，或无法使用的服务，无论我们是否已经 被告知其可能性。
            </li>
            <li>
              在适用法律法规允许的最大范围内，您承认
              并同意您与任何其他第三方就任何相关事宜而产生的任何索赔或争议
              服务，包括但不限于任何承运人，
              版权所有者或其他用户，即您与该第三方之间，并且您不可撤销地
              同意释放、赔偿并使我们、我们的母公司、子公司免受损害，
              和附属公司，以及我们各自的管理人员、董事、雇员、代理人和
              顾问免于承担任何及所有索赔、要求和/或损害赔偿（实际和间接）
              任何种类和性质的，已知和未知的，由其引起或以任何方式与之相关的 此类索赔或争议。
            </li>
            <li>
              我们对您的全部责任，无论是基于诉讼还是合同、侵权行为的索赔
              （包括疏忽）、违反法定义务或因其他原因引起的，或在
              与这些条款相关的（如果有）应仅限于付款总额 您在过去 6
              个月内向我们做出的。本节中的限制仅适用于 适用法律允许的最大范围。
            </li>
          </ol>
        </div>
      </div>
    ),
  },
  {
    id: 'personal-information',
    title: '8. 您的个人信息',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          我们收集和处理 {PRODUCT_NAME} 用户的个人数据。所有个人数据均根据我们的隐私政策处理，
          该政策通过引用明确纳入本条款。
        </p>
        <p>
          具体而言，您承认并同意我们不对您访问和/或使用 {PRODUCT_NAME} 的设备上的 Touch ID、
          指纹认证或类似传感器或生物识别技术（如果可用）负责，我们明确排除对此类 Touch ID、
          指纹认证或类似传感器或生物识别技术作为保护访问和使用 {PRODUCT_NAME} 和/或服务的手段
          的质量、准确性或性能的任何法定或其他保证、条件、条款或承诺。
        </p>
      </div>
    ),
  },
  {
    id: 'third-party-providers',
    title: '9. 第三方提供商',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          9.1 您承认{PRODUCT_NAME}的某些部分以及某些内容和服务 通过 {PRODUCT_NAME}{' '}
          提供的（用户内容除外）或 由第三方维护（包括非 LLM、插件和 API），而非我们维护。由
          使用本服务，您承认并同意我们不负责审查或
          评估内容、准确性、完整性、可用性、及时性、有效性，
          版权合规性、合法性、体面性、质量或任何此类第三方的任何其他方面 方内容或服务。
        </p>
        <p>
          9.2 我们不保证内容或服务的质量、可靠性或适用性 由任何第三方提供、通过 {PRODUCT_NAME}{' '}
          提供、宣传或链接 ，并且我们不对您的访问、使用、互动或
          与任何第三方提供的内容或服务的关系。您同意
          您访问、查看和与所有此类服务和内容互动的风险由您自行承担。如果您 通过{PRODUCT_NAME}
          访问第三方服务，您必须遵守任何条款和 条件（例如用户条款、可接受使用政策、隐私政策和内容
          政策）适用于这些服务。您承认并同意，您使用 第三方 LLM、插件和 API
          可能受该第三方制定的条件约束 如果您的输入是 有害或含有不当内容）。
        </p>
        <p>9.3 您同意，对于任何 因您与第三方之间的任何通信或交易而产生的 派对。</p>
        <p>
          9.4 根据我们的隐私政策，我们可能会探索和集成提供的开发者工具
          由第三方不时启用或促进特性、功能或业务 适用于{PRODUCT_NAME}平台并遵守本协议。
        </p>
      </div>
    ),
  },
  {
    id: 'external-links',
    title: '10. 外部链接',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          如果 {PRODUCT_NAME}
          包含任何指向其他网站或资源的链接，则适用以下规定：
        </p>
        <ol className="list-[lower-alpha] space-y-2 pl-4">
          <li>
            尽管这些网站或资源是经过精心挑选的，但我们不对 任何站外页面或链接到{' '}
            的任何其他网站或资源的内容或准确性
            {PRODUCT_NAME}（包括通过广告或 通过任何搜索引擎）。
          </li>
          <li>
            我们也不对这些网站或资源处理您的个人数据负责。关于此类处理，您可能需要参考它们的隐私政策。
          </li>
          <li>
            事实上，我们包括链接到这些外部网站和资源并不意味着
            对此类运营商、内容或观点的任何认可或关联。你对 从{PRODUCT_NAME}
            链接的网站或资源受任何条款和条件的约束 适用于这些网站或资源。
          </li>
        </ol>
      </div>
    ),
  },
  {
    id: 'governing-laws',
    title: '11. 适用法律',
    content: (
      <div className="text-base font-normal text-white">
        <p>
          在适用法律法规允许的最大范围内，本条款的有效性、解释、修改、补充、终止、执行以及
          因本条款产生或与本条款相关的任何争议或索赔将受新加坡法律管辖并按其解释，但这不应
          阻止我们在任何其他司法管辖区的任何有管辖权的法院提起保护我们知识产权的诉讼。
        </p>
      </div>
    ),
  },
  {
    id: 'dispute-resolution',
    title: '12. 争议解决',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          12.1 任何争议、争论或索赔（无论是合同、侵权或其他因本条款产生、与本条款相关或
          与本条款有关的，包括其存在、有效性、解释、履行、违约或终止）应首先通过您与我们
          之间的友好协商解决。如果协商失败，将提交新加坡国际仲裁中心（"SIAC"）管理的仲裁，
          并根据当事方提交仲裁通知时生效的SIAC仲裁规则最终解决。仲裁地点为新加坡。
          仲裁程序将以英语进行。
        </p>

        <p>
          12.2 如果可能，仲裁将通过视频会议进行，但如果仲裁员确定应当面进行听证，
          听证地点将由双方协商确定，如果协商不成，听证地点将由独任仲裁员确定。您和公司
          同意，任何一方提供的任何和解金额在仲裁员确定最终裁决（如有）之前不会被任何一方
          向仲裁员披露。
        </p>

        <p>
          12.3 您和公司同意争议必须仅以个人为基础提出，不得作为任何声称的集体、
          合并或代表性诉讼中的原告或集体成员提出。集体仲裁、集体诉讼和代表性诉讼均被禁止。
          仅提供个人救济。双方同意在完成基础索赔和所有其他索赔的仲裁后，将任何公共禁令救济
          请求分离并在法院诉讼。前述规定不阻止任何一方参与全集体和解。您和公司明知并不可
          撤销地放弃在任何诉讼、程序或反诉中的陪审团审判权。
        </p>

        <p>
          12.4 如果本第12节条款的任何部分被认定为非法或不可执行，其余部分将继续有效，
          但如果部分非法或不可执行的认定将允许集体仲裁、集体诉讼或代表性诉讼，
          则整个争议解决条款将完全不可执行。
        </p>
      </div>
    ),
  },
  {
    id: 'term-and-termination',
    title: '13. 期限和终止',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          13.1 期限。本协议自生效日期开始，直至以下较早者为止：(a) 所有条款到期或终止， 或 (b)
          根据第13.2节终止本协议。
        </p>

        <div>
          <p className="font-semibold">13.2 终止</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              您可以随时自由停止使用我们的服务。您可以随时通过您的账户设置或联系 {PRODUCT_NAME}
              <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a> 终止您的账户和本协议。
            </li>
            <li>
              如果您违反本协议的任何条款，则您访问服务的授权和本协议将立即自动终止。 此外，
              {PRODUCT_NAME} 可自行决定，随时因任何原因或无原因，有通知或无通知地
              终止本协议或您的账户，或暂停或终止您对服务的访问，而不因此类终止对您承担任何责任。
            </li>
            <li>
              我们可能决定停止我们的服务，但如果我们这样做，我们将提前通知您并为任何预付的
              未使用服务退款。
            </li>
          </ol>
        </div>

        <p>
          13.3 如果您认为我们错误地暂停或终止了您的账户，您可以通过联系我们的支持团队
          <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a> 向我们提出申诉。
        </p>
      </div>
    ),
  },
  {
    id: 'miscellaneous',
    title: '14. 其他条款',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          14.1 本条款是您与我们之间关于您使用服务的完整协议，并取代我们之间关于您使用服务的
          所有先前协议。
        </p>

        <p>
          14.2 任何一方未能行使或执行本条款的任何权利或补救措施，不构成对此类权利或补救措施的
          放弃，也不应阻止或限制进一步行使该权利或任何其他权利或补救措施。任何权利或补救措施的
          单一或部分行使不应阻止或限制进一步行使该权利或任何其他权利或补救措施。本条款任何条款的
          任何放弃只有在书面形式并由相关方签署时才有效。
        </p>

        <p>
          14.3 在本条款终止或到期时，任何按其性质或明示条款应继续有效的条款，包括但不限于
          与各方责任相关的任何义务或各方提供的赔偿（如有），将在该终止或到期后继续有效。
        </p>

        <p>
          14.4 如果本条款的任何条款被法院或法庭认定为无效、非法或不可执行，并且可以在不改变
          本条款本质的情况下删除，则应被视为已删除，而不影响本条款其余条款的有效性和可执行性。
          如果无效、非法或不可执行的条款在不改变本条款本质的情况下无法删除，我们可以修改本条款
          以在实现原条款意图所需的范围内纠正此类无效性、非法性或不可执行性。
        </p>

        <p>
          14.5
          我们欢迎对服务的反馈、评论和改进建议（“反馈”）。您承认并明确同意，任何反馈的贡献不会也不会授予您任何关于服务或任何此类反馈的权利、所有权或利益。所有反馈成为公司的独家和专有财产，公司可以在未经进一步通知或补偿您的情况下，以任何方式和任何目的使用和披露反馈，并且您不会保留任何专有或其他权利或主张。您特此将您可能拥有或与任何反馈相关的所有权利、所有权和利益（包括但不限于任何专利、版权、商业秘密、商标、展示方法、专有技术、道德权利和任何其他所有知识产权）转让给公司。
        </p>

        <p>14.6 各方应自行承担履行本协议项下任何义务所产生的费用，除非本协议另有明确规定。</p>

        <p>
          14.7
          本协议条款中并无旨在创建或将会创建双方之间的合伙关系，亦不确立一方为另一方代理人。任何一方均无权以任何方式或目的代表、约束、以对方名义签约或为对方承担责任。
        </p>

        <p>
          14.8
          各方应，并应尽一切合理努力确保任何必要的第三方将执行并交付此类文件并履行此类行为，以合理地实现本协议条款的完全效力。
        </p>

        <div>
          <p>14.9 尽管本协议条款中另有规定：</p>
          <ol className="list-[lower-alpha] space-y-2 pl-4">
            <li>
              未经我们事先书面同意，你不得（全部或部分）转让、转移、变更、放弃、外包、分包或委托本协议条款项下的任何权利、责任和/或义务；和
            </li>
            <li>
              我们可能未经您的事先同意，将本协议项下的任何权利、责任和/或义务（全部或部分）转让、让与、变更、放弃或分包给任何其他关联公司、子公司或任何与我们服务相关的业务的承继人。
            </li>
          </ol>
        </div>

        <p>14.10 未参与本协议的任何人均无权执行本协议的任何条款。</p>

        <p>
          14.11
          本协议以英语撰写。如果本协议被翻译成任何非英语的语言，在存在任何不一致的情况下，英文版本应优先适用，除非适用法律和法规另有规定。
        </p>
      </div>
    ),
  },
  {
    id: 'contact-information',
    title: '15. 联系信息',
    content: (
      <div className="space-y-4 text-base font-normal text-white">
        <p>
          如果您对本条款有任何投诉、建议或其他问题，请通过电子邮件{' '}
          <a href={`mailto:${PRODUCT_EMAIL}`}>{PRODUCT_EMAIL}</a>
          或访问 <a href="https://x.com/CodeFlicker_ai">https://x.com/CodeFlicker_ai</a> 联系我们。
        </p>
        <p>我们将尽快审查相关问题，并在验证您的身份后及时回复您。</p>
      </div>
    ),
  },
];

const TermOfUse: React.FC = () => {
  return (
    <div className="size-full">
      <NavBar />
      <PageWithTOC
        title="服务条款"
        subtitle="发布日期：2025/08/04   生效日期：2025/08/04"
        sections={termOfUseSections}
      />
      {/* <Signature className="fixed bottom-[244px] right-[120px]" /> */}
    </div>
  );
};

export default TermOfUse;